import React, { useContext, useEffect, useState } from "react";
import { InvestmentContextFull } from "../investment-process-full";
import { MultistepFormButtonsV2 } from "../../../../components/vertical-multistep-form/multistep-form-buttons";
import { AppContext } from "../../direct-router";
import API_CLIENT from "../../../../utility/api-client";
import { Investment } from "../../../../types/investment_types";
import { Text, Card, Spacer } from "@geist-ui/core";
import { Check } from "@geist-ui/icons";

type DataProtectionProps = {
  back: () => void;
  next: () => void;
};

type Selection = 'share' | 'no_share' | null;

export default function DataProtection({ back, next }: DataProtectionProps) {
  const investment_context = useContext(InvestmentContextFull);
  const app_context = useContext(AppContext);
  const investment = investment_context.investment;

  // Single source of truth for selection
  const [selection, setSelection] = useState<Selection>(null);

  const submit = () => {
    window.scrollTo(0, 0);
    if (investment === null) return;
    investment_context.setLoading(true);
    
    // Logic: If selection is 'share', hide_data is false. 
    // If selection is 'no_share', hide_data is true.
    const hide_data = selection === 'no_share';

    API_CLIENT.putInvestmenDataProtection(
      app_context.token,
      investment.id,
      (investment: Investment) => {
        investment_context.setInvestment(investment);
      },
      (error: string) => {
        console.log(error);
      },
      hide_data
    );
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selection) submit();
  };

  if (!investment) return null;

  return (
    <div className="flex flex-col gap-8 w-full max-w-4xl min-h-screen">
      <div className="flex flex-col gap-4 mb-2">
        <Text h3 style={{ margin: 0, fontSize: 'clamp(20px, 5vw, 24px)', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '-0.02em' }}>
          Weitergabe persönlicher Daten
        </Text>
      </div>

      <div className="flex flex-col gap-4">
        
        {/* OPTION 1: SHARE DATA */}
        <div 
            onClick={() => setSelection('share')}
            className={`
                border rounded-xl p-6 cursor-pointer transition-all flex items-start gap-4
                ${selection === 'share' 
                    ? 'border-gray-900 ring-1 ring-gray-900 bg-gray-50' 
                    : 'border-gray-200 hover:border-gray-400 bg-white'}
            `}
            style={{ padding: 'clamp(16px, 3vw, 24px)' }}
        >
            <div className={`
                flex items-center justify-center w-6 h-6 rounded-full border border-gray-300 mt-1 shrink-0
                ${selection === 'share' ? 'bg-black border-black' : 'bg-white'}
            `}>
                {selection === 'share' && <Check size={14} color="white" />}
            </div>
            <div className="flex flex-col gap-2">
                <Text b style={{ margin: 0, fontSize: 'clamp(15px, 4vw, 16px)' }}>Datenweitergabe zustimmen</Text>
                <Text p style={{ margin: 0, fontSize: 'clamp(13px, 3.5vw, 14px)', color: '#666', lineHeight: '1.6' }}>
                    Ich bin mit der Weitergabe meiner persönlichen Daten,
                    insbesondere Name, Anschrift und Beteiligungshöhe, an andere
                    Gesellschafter/Treugeber, falls diese angefordert werden,
                    einverstanden.
                </Text>
            </div>
        </div>

        {/* OPTION 2: DO NOT SHARE DATA */}
        <div 
            onClick={() => setSelection('no_share')}
            className={`
                border rounded-xl p-6 cursor-pointer transition-all flex items-start gap-4
                ${selection === 'no_share' 
                    ? 'border-gray-900 ring-1 ring-gray-900 bg-gray-50' 
                    : 'border-gray-200 hover:border-gray-400 bg-white'}
            `}
            style={{ padding: 'clamp(16px, 3vw, 24px)' }}
        >
             <div className={`
                flex items-center justify-center w-6 h-6 rounded-full border border-gray-300 mt-1 shrink-0
                ${selection === 'no_share' ? 'bg-black border-black' : 'bg-white'}
            `}>
                {selection === 'no_share' && <Check size={14} color="white" />}
            </div>
            <div className="flex flex-col gap-2">
                <Text b style={{ margin: 0, fontSize: 'clamp(15px, 4vw, 16px)' }}>Widerspruch</Text>
                <Text p style={{ margin: 0, fontSize: 'clamp(13px, 3.5vw, 14px)', color: '#666', lineHeight: '1.6' }}>
                    Ich untersage hiermit der iVC Venture Innovation Fund GmbH & Co.
                    geschlossene Investment KG, der Treuhandkommanditistin, der
                    Kapitalverwaltungsgesellschaft, ihren Gesellschaftern und
                    Dienstleistern, meine persönlichen Daten an andere
                    Gesellschafter/Treugeber oder deren Vertreter weiterzugeben.
                </Text>
            </div>
        </div>

        <div className="bg-gray-50 p-5 rounded-xl border border-gray-100 text-sm text-gray-500 leading-relaxed" style={{ fontSize: 'clamp(12px, 3vw, 13px)' }}>
           <Text b style={{ display: 'block', marginBottom: '4px', fontSize: 'inherit' }}>Hinweis der Gesellschaft:</Text>
           Sie können diese Entscheidung jederzeit
           schriftlich gegenüber der iVC Venture Innovation Fund GmbH & Co.
           geschlossene Investment KG, Rudower Chaussee 19, 12489 Berlin,
           widerrufen.
        </div>
      </div>

      <Spacer h={2} />

      <form onSubmit={handleSubmit} className="mt-4">
        <MultistepFormButtonsV2
          backFunction={() => back()}
          back={true}
          disabled={selection === null}
          nextButtonText="Weiter"
        />
      </form>
    </div>
  );
}
